import LogoutButton from "@/components/LogoutButton";
import Row from "@/components/Ui/Row";
import VendorButtons from "@/components/UserButton/VendorButtons";
import User from "@/components/portal/user/User";
import { Card } from "@/components/shadcn/card";
import { ProfileUser } from "@/types/user";

type ButtonMenuProps = {
  isOpen: boolean;
  user?: any;
  closeFunction: () => void;
};

const ButtonMenu = ({ isOpen, user, closeFunction }: ButtonMenuProps) => {
  if (!isOpen) return null;

  return (
    <div className="absolute top-full right-0 z-40 w-[430px]">
      <Card className="py-0">
        <div data-testid="user-menu" className="px-2">
          <Row
            className="w-full justify-between px-2 py-4"
            right
            data-testid="user-email"
          >
            {user && (
              <User
                data={
                  {
                    email: user.email,
                    settings: {
                      firstName: user.given_name,
                      lastName: user.family_name,
                      picture: user.picture,
                    },
                  } as ProfileUser
                }
              />
            )}
            <LogoutButton text="Sign out" />
          </Row>

          <VendorButtons closeFunction={closeFunction} />
        </div>
        <div className="mx-2 border-t" />
        <div className="text-muted-foreground row-left space-x-1.5 p-6 text-xs sm:text-2xl">
          <a
            className="hover:text-foreground text-xs"
            href="https://sesamy.com/privacy-policy"
            target="_blank"
          >
            Privacy Policy
          </a>
          <span className="leading-0">•</span>
          <a
            className="hover:text-foreground text-xs"
            href="https://sesamy.com/terms-and-conditions"
            target="_blank"
          >
            Terms & Conditions
          </a>
        </div>
      </Card>
    </div>
  );
};

export default ButtonMenu;
